<template lang="pug">
  .scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
    :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tabHead")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
        tbody.table__body(v-for="item in tabData")
          tr.table__row
            td.table__cell
              .table__cell-content
                //.table__cell-content
                //  a.toggle(
                //  v-if="item.houses.length > 0"
                //  @click.prevent="toggleRow($event)"
                //  ) {{item.name}}
                .table__cell-content.table__cell-content_short
                  span {{item.name}}
            td.table__cell
              .table__cell-content
                //.table__cell-content
                //  a.toggle(
                //  v-if="item.houses.length > 0"
                //  @click.prevent="toggleRow($event)"
                //  ) {{item.name}}
                .table__cell-content.table__cell-content_short
                  span {{item.camp.name}}
            td.table__cell
              .table__cell-content {{ setDate(item) }}
            <!--td.table__cell-->
              <!--.table__cell-content(-->
                <!--v-if="Number(item.price_from) && Number(item.price_to)"-->
              <!--) {{ item.price_from }} - {{ item.price_to }}-->
              <!--.table__cell-content(-->
                <!--v-else-->
              <!--) - -->
            td.table__cell
              .table__cell-content(
              v-if="item.capacity"
              ) {{ item.capacity }}
              .table__cell-content(
              v-else
              ) -
            td.table__cell
              .table__cell-content(
              v-if="item.free_places"
              ) {{ item.free_places }}
              .table__cell-content(
              v-else
              ) -
            td.table__cell.fixed
              .table__cell-content.table__cell-content_align-right
                router-link.button.button_square.table__cell-control(
                :to="`/pages/manager/shifts/${item.id}/`"
                )
                  img(src="@/assets/images/icons/icon-edit.svg")
                button.button.button_square.table__cell-control(
                @click.prevent="onDeleteShift(item)"
                )
                  img(src="@/assets/images/icons/trash.svg")
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "ManagerShiftsRegistryScrollFixTable",
  props: [
    "tab-data",
    "tab-head"
  ],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  },
  methods: {
    setDate(item) {
      let start = item.date_started;
      start = start.split("-").reverse().join(".");
      let finish = item.date_finished;
      finish = finish.split("-").reverse().join(".");
      return start + " - " + finish;
    },
    onDeleteShift(shift) {
      this.$emit("on-delete-shift", shift);
    }
  },
  mounted() {

  }
};
</script>
